import { IHocLaiThiLaiActionTypes } from "../../action-types/hoc-lai-thi-lai/IHocLaiThiLaiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHocLaiThiLaiReducer } from "../../reducer-model/hoc-lai-thi-lai/IHocLaiThiLaiReducer";

export const iniState: IHocLaiThiLaiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    hocLaiThiLais: [],
    focusedTab: "thi-lai",
    trangThaiHocs: [],
    namHoc: "",
    hocKy: 0
}

export const hocLaiThiLaiReducer = (state: IHocLaiThiLaiReducer = iniState, action: IHocLaiThiLaiActionTypes): IHocLaiThiLaiReducer => {
    switch (action.type) {
        case "HOC_LAI_THI_LAI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            }
        case "HOC_LAI_THI_LAI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                hocLaiThiLais: action.payload,
            }
        case "HOC_LAI_THI_LAI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        case "HOC_LAI_THI_LAI_CHANGE_FOCUSED_TAB_CHANGE":
            return {
                ...state,
                focusedTab: action.payload,
            }
        case "HOC_LAI_THI_LAI_CHANGE_TRANG_THAI_HOC":
            return {
                ...state,
                trangThaiHocs: action.payload,
            }
        case "HOC_LAI_THI_LAI_CHANGE_NAM_HOC":
            return {
                ...state,
                namHoc: action.payload,
            }
        case "HOC_LAI_THI_LAI_CHANGE_HOC_KY":
            return {
                ...state,
                hocKy: action.payload,
            }
        case "HOC_LAI_THI_LAI_CHANGE_FOCUSED_VALUE_LOP":
            return {
                ...state,
                focusedValueLop: action.payload,
            }
        default:
            return state;
    }
}